import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import ContainerHeader from 'components/common/ContainerHeader';
import CustomerItem from './CustomerItem';

import {containerStyles, scrollStyles, colors} from 'styles/shared';
import dateHelper from 'helpers/dateHelper';

const CustomersContainer = styled.div`
  width: 72.7rem;
  height: 80.9rem;
  z-index: 10;
  padding: 5rem;
  margin-right: 5rem;
  margin-bottom: 5rem;
  position: relative;
  ${containerStyles};
`;

const ListHeader = styled.div`
  font-size: 1.8rem;
  line-height: 2.2rem;
  font-weight: bold;
  margin: 3rem 0 1rem;
  color: ${colors.darkBlue_darker};
  display: flex;
  width: 100%;

  span {
    flex: 1;
    &.header-center {
      margin-left: 2.5rem;
    }
  }
`;

const ListContainer = styled.div`
  height: 57rem;
  overflow-y: auto;
  padding-right: 2rem;
  ${scrollStyles}
`;

const ItemText = styled.div`
  display: flex;
  width: 100%;

  span {
    flex: 1;
  }
`;

CustomersList.propTypes = {
  customers: PropTypes.array.isRequired
};

function CustomersList({customers}) {
  function getRandomColor() {
    let keys = Object.keys(colors);

    return colors[keys[(keys.length * Math.random()) << 0]];
  }

  function renderCustomer(customer, isLastItem) {
    let displayDate = dateHelper.displayDate(customer.date_joined);
    let text = (
      <ItemText>
        <span>{customer.name}</span>
        <span>{customer.amount}</span>
        <span>{displayDate}</span>
      </ItemText>
    );

    let item = {
      id: customer.id,
      text,
      color: getRandomColor(),
      lastItem: isLastItem
    };

    return <CustomerItem key={customer.id} item={item} />;
  }

  function render() {
    return (
      <CustomersContainer>
        <ContainerHeader>Customers</ContainerHeader>

        <ListHeader>
          <span>Name</span>
          <span className="header-center">$</span>
          <span className="header-right">Date joined</span>
        </ListHeader>

        <ListContainer>
          {customers.map((user, index) => {
            let isLastItem = index + 1 === customers.length;

            return renderCustomer(user, isLastItem);
          })}
        </ListContainer>
      </CustomersContainer>
    );
  }

  return render();
}

export default CustomersList;
